import {getCommonStoryParams} from '~/storyblok/api/options';
import {getBranchStoryblokSlug} from '~/utils/branch';

export default defineNuxtRouteMiddleware(async (to, from) => {
	const {$storyblokApi} = useNuxtApp();

	if (to.name === 'branch-sluzby-slug' && to.params.slug && to.params.branch && to.params.branch !== from.params.branch) {
		const fullSlug = getBranchStoryblokSlug(String(to.params.branch), `sluzby/${String(to.params.slug)}`);
		const encodedSlug = encodeURIComponent(encodeURIComponent(fullSlug));

		try {
			await $storyblokApi.get(`stories/${encodedSlug}`, getCommonStoryParams());
		} catch (error) {
			if (from.params.branch === 'globus') {
				return navigateTo({
					name: to.name,
					params: {
						...to.params,
						branch: from.params.branch,
					},
					query: to.query,
					hash: to.hash,
				});
			} else {
				return navigateTo({
					name: 'branch-sluzby',
					params: {...to.params},
					query: to.query,
					hash: to.hash,
				});
			}
		}
	}
});
